
import moment from 'moment';
import React from 'react';
import Moment from 'react-moment';


export function DateDisplay({ value, format='DD.MM.YYYY'}) {
  if (value) {
    return <Moment format={format}>{value}</Moment>
  }
  return <React.Fragment />;
}


export function TimeDisplay({ value, format='HH:mm'}) {
  if (value) {
    return <Moment format={format}>{value}</Moment>
  }
  return <React.Fragment />;
}


export function DateTimeDisplay({ value, format='DD.MM.YYYY HH:mm'}) {
  if (value) {
    return <Moment format={format}>{value}</Moment>
  }
  return <React.Fragment />;
}


export function SequenceDisplay({ values, separator=' / ', defaults='-', prefix=undefined, postfix = undefined}) {
  let items = values.filter((value) => value && value !== '');
  return (
    <React.Fragment>
      {(items.length > 0 && prefix)}
      {items.length > 0 && items.join(separator)}
      {items.length === 0 && defaults}
      {(items.length > 0 && postfix)}
    </React.Fragment>
  );
}


export function DurationDisplay({ value }) {
  const delta = moment().diff(moment(value));
  const duration = moment.duration(delta);
  let display = [];

  if (moment().isBefore(moment(value))) {
    display.push('-');
  }
  if (duration.years() > 0) {
    display.push(moment.duration(duration.years(), 'years').humanize());
  }
  if (duration.months() > 0) {
    display.push(moment.duration(duration.months(), 'months').humanize());
  }
  if (duration.years() === 0 && duration.days() > 0) {
    display.push(moment.duration(duration.days(), 'days').humanize());
  }

  return (
    <React.Fragment>
      {display.join(' ')}
    </React.Fragment>
  )
}
